import Desktop from 'components/Header/desktop';
import { SETTINGS_DROPDOWN_ITEM } from 'components/Header/HeaderDropdown';
import Mobile from 'components/Header/mobile';
import Tablet from 'components/Header/tablet';
import { useAuth } from 'contexts/auth';
import { useViewport } from 'contexts/viewport';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const getNavOptions = (path, role, t) => {
    if (!role) {
        return [
            {
                key: 'lobby',
                text: t('nav.lobby', 'Lobby'),
                link: '/',
                icon: 'home',
            },
            {
                key: 'rubrics',
                text: t('nav.rubrics', 'Rubrics'),
                link: '/rubrics',
                icon: 'dashboard',
            },
        ];
    }

    return path === '/'
        ? [
              {
                  key: 'lobby',
                  text: t('nav.lobby', 'Lobby'),
                  link: '/',
                  icon: 'home',
              },
              {
                  key: 'rubrics',
                  text: t('nav.rubrics', 'Rubrics'),
                  link: '/rubrics',
                  icon: 'dashboard',
              },
          ]
        : {
              student: [
                  {
                      key: 'lobby',
                      text: t('nav.lobby', 'Lobby'),
                      link: '/',
                      icon: 'home',
                  },
                  {
                      key: 'assignments',
                      text: t('nav.assignments', 'Assignments'),
                      link: '/assignments',
                      icon: 'task',
                  },
              ],
              instructor: [
                  {
                      key: 'lobby',
                      text: t('nav.lobby', 'Lobby'),
                      link: '/',
                      icon: 'home',
                  },
                  {
                      key: 'assignments',
                      text: t('nav.assignments', 'Assignments'),
                      link: '/assignments',
                      icon: 'task',
                  },
                  {
                      key: 'rubrics',
                      text: t('nav.rubrics', 'Rubrics'),
                      link: '/rubrics',
                      icon: 'dashboard',
                  },
                  {
                      key: 'people',
                      text: t('nav.people', 'People'),
                      link: '/people',
                      icon: 'teams',
                  },
              ],
              ta: [
                  {
                      key: 'assignments',
                      text: t('nav.assignments', 'Assignments'),
                      link: '/assignments',
                      icon: 'task',
                  },
                  {
                      key: 'rubrics',
                      text: t('nav.rubrics', 'Rubrics'),
                      link: '/rubrics',
                      icon: 'dashboard',
                  },
                  {
                      key: 'people',
                      text: t('nav.people', 'People'),
                      link: '/people',
                      icon: 'teams',
                  },
              ],
          }[role];
};

const getDropdownOptions = (hasCourseSelected, role, t) => {
    const universalDropdownOptions = [
        { key: 'user' },
        { key: 'divider' },
        { key: SETTINGS_DROPDOWN_ITEM.PROFILE, value: t('header.account-settings', 'Account Settings') },
    ];

    return [
        ...universalDropdownOptions,
        ...(hasCourseSelected
            ? [
                  ...(role === 'instructor'
                      ? [
                            {
                                key: SETTINGS_DROPDOWN_ITEM.COURSE_SETTINGS,
                                value: t('header.course-settings', 'Course Settings'),
                            },
                            { key: SETTINGS_DROPDOWN_ITEM.PREFERENCES, value: t('header.preferences', 'Preferences') },
                        ]
                      : []),
                  {
                      key: SETTINGS_DROPDOWN_ITEM.SWITCH_COURSE,
                      value: t('header.switch-course', 'Switch Course'),
                  },
              ]
            : []),
    ];
};

const Header = () => {
    const { auth } = useAuth();
    const location = useLocation();
    const { device } = useViewport();
    const { t } = useTranslation();

    const hasCourseSelected = Boolean(auth.owner_account_id);
    const navOptions = getNavOptions(location.pathname, auth.role, t);
    const dropdownOptions = getDropdownOptions(hasCourseSelected, auth.role, t);

    const props = {
        hasCourseSelected,
        navOptions,
        dropdownOptions,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return isEmpty(auth) ? null : renderResponsiveLayout(device);
};

export default Header;
